import React from "react";
import IncomeOrdersPage from "./IncomeOrdersPage";
import useIncomeOrders from "./useIncomeOrders";

function IncomeOrders() {
  return <IncomeOrdersPage {...useIncomeOrders()} />;
}

export default IncomeOrders;
